import React, {memo, useEffect, useMemo} from "react"
import {Breadcrumb, Button, Col, Row} from "antd"
import {NavLink, useLocation} from "react-router-dom"
import {useDispatch, useSelector} from "react-redux"
import {StateType} from "../store/store"
import {logout} from "../store/appReducer"
import {HeaderNotification} from "./HeaderNotification/HeaderNotification"
import {AttributesVersionResponse, CompanyResponse, ObjectGroupResponse, ObjectResponse, PSLeakDeviceResponse, UserGroupResponse, UserResponse} from "../models/response"

const profile = [
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        key={0}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
            fill="#111827"
        ></path>
    </svg>,
]

const toggler = [
    <svg
        width="20"
        height="20"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        key={0}
    >
        <path
            d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
    </svg>,
]

type PropsTypes = {
    onPress: () => void
}
export const Header: React.FC<PropsTypes> = memo(({onPress}) => {
    const location = useLocation<{ company?: CompanyResponse, objectGroup?: ObjectGroupResponse, object?: ObjectResponse, psLeakDevice?: PSLeakDeviceResponse,
        userGroup?: UserGroupResponse, user?: UserResponse , version?: AttributesVersionResponse}>()
    const pathname = location?.pathname
    const companyForm = location?.state?.company
    const objectGroupForm = location?.state?.objectGroup
    const userGroupForm = location?.state?.userGroup
    const userForm = location?.state?.user
    const objectForm = location?.state?.object
    const psLeakDeviceForm = location?.state?.psLeakDevice
    const versionForm = location?.state?.version

    const dispatch = useDispatch()
    const profile = useSelector((state: StateType) => state.appReducer.profile)
    const company = useSelector((state: StateType) => state.companyReducer.company)
    const userGroup = useSelector((state: StateType) => state.userGroupReducer.userGroup)
    const user = useSelector((state: StateType) => state.userReducer.user)
    const objectGroup = useSelector((state: StateType) => state.objectGroupReducer.objectGroup)
    const object = useSelector((state: StateType) => state.objectReducer.object)
    const psLeakDevice = useSelector((state: StateType) => state.psLeakDeviceReducer.psLeakDevice)
    const psLeakDeviceLog = useSelector((state: StateType) => state.psLeakDeviceLogReducer.psLeakDeviceLog)
    const psLeakDeviceLocalLog = useSelector((state: StateType) => state.psLeakDeviceLocalLogReducer.psLeakDeviceLocalLog)
    const psLeakDeviceIndication = useSelector((state: StateType) => state.psLeakDeviceIndicationReducer.psLeakDeviceIndication)
    const version = useSelector((state: StateType) => state.attributesVersionReducer.version)
    const controller = useMemo(() => new AbortController(), [])

    useEffect(() => {
        return () => {
            controller.abort()
        }
    }, [controller])

    const breadcrumbName = useMemo(() => {
        const arr: any = []
        const routes = pathname?.split('/')

        switch (routes[1]) {
            case 'dashboard':
                arr.push(createBreadcrumb('/dashboard', 'Главная'))
                break

            case 'userGroup':
                arr.push(createBreadcrumb('/userGroup', 'Группы пользователей'))
                if (routes[2]) {
                    if (userGroup) {
                        arr.push(createBreadcrumb(`/userGroup/${userGroup.id}`, userGroup.name))
                    }
                }
                break
            case 'userGroupForm':
                arr.push(createBreadcrumb('/userGroup', 'Группы пользователей'))
                if (userGroupForm) {
                    arr.push(createBreadcrumb(`/userGroup/${userGroupForm.id}`, userGroupForm.name))
                    arr.push(createBreadcrumb(`/userGroupForm`, 'Обновление группы', {userGroup: objectGroupForm}))
                } else arr.push(createBreadcrumb(`/userGroupForm`, 'Новая группа'))
                break

            case 'user':
                arr.push(createBreadcrumb('/user', 'Пользователи'))
                if (routes[2]) {
                    if (user) {
                        arr.push(createBreadcrumb(`/user/${user.id}`, user.name))
                    }
                }
                break
            case 'userForm':
                arr.push(createBreadcrumb('/user', 'Пользователи'))
                if (userForm) {
                    arr.push(createBreadcrumb(`/user/${userForm.id}`, userForm.name))
                    arr.push(createBreadcrumb(`/userForm`, 'Обновление пользователя', {userGroup: objectGroupForm}))
                } else arr.push(createBreadcrumb(`/userForm`, 'Новый пользователь'))
                break

            case 'company':
                arr.push(createBreadcrumb('/company', 'Компании'))
                if (routes[2]) {
                    if (company) {
                        arr.push(createBreadcrumb(`/company/${company.id}`, company.name))
                    }
                }
                break
            case 'companyForm':
                arr.push(createBreadcrumb('/company', 'Компании'))
                if (companyForm) {
                    arr.push(createBreadcrumb(`/company/${companyForm.id}`, companyForm.name))
                    arr.push(createBreadcrumb(`/companyForm`, 'Обновление компании', {company: companyForm}))
                } else arr.push(createBreadcrumb(`/companyForm`, 'Новая компания'))
                break

            case 'objectGroup':
                arr.push(createBreadcrumb('/objectGroup', 'Группы объектов'))
                if (routes[2]) {
                    if (objectGroup) {
                        arr.push(createBreadcrumb(`/objectGroup/${objectGroup.id}`, objectGroup.name))
                    }
                }
                break
            case 'objectGroupForm':
                arr.push(createBreadcrumb('/objectGroup', 'Группы объектов'))
                if (objectGroupForm) {
                    arr.push(createBreadcrumb(`/objectGroup/${objectGroupForm.id}`, objectGroupForm.name))
                    arr.push(createBreadcrumb(`/objectGroupForm`, 'Обновление группы', {objectGroup: objectGroupForm}))
                } else arr.push(createBreadcrumb(`/objectGroupForm`, 'Новая группа'))
                break

            case 'object':
                arr.push(createBreadcrumb('/object', 'Объекты'))
                if (routes[2]) {
                    if (object) {
                        arr.push(createBreadcrumb(`/object/${object.id}`, object.name))
                    }
                }
                break
            case 'objectForm':
                arr.push(createBreadcrumb('/object', 'Объекты'))
                if (objectForm) {
                    arr.push(createBreadcrumb(`/object/${objectForm.id}`, objectForm.name))
                    arr.push(createBreadcrumb(`/objectForm`, 'Обновление объекта', {object: objectForm}))
                } else arr.push(createBreadcrumb(`/objectForm`, 'Новый объект'))
                break

            case 'psLeakDevice':
                arr.push(createBreadcrumb('/psLeakDevice', 'Оборудование'))
                if (routes[2]) {
                    if (psLeakDevice) {
                        arr.push(createBreadcrumb(`/psLeakDevice/${psLeakDevice.id}`, psLeakDevice.name))
                    }
                }
                break
            case 'psLeakDeviceForm':
                arr.push(createBreadcrumb('/psLeakDevice', 'Оборудование'))
                if (psLeakDeviceForm) {
                    arr.push(createBreadcrumb(`/psLeakDevice/${psLeakDeviceForm.id}`, psLeakDeviceForm.name))
                    arr.push(createBreadcrumb(`/psLeakDeviceForm`, 'Обновление оборудования', {psLeakDevice: psLeakDeviceForm}))
                } else arr.push(createBreadcrumb(`/psLeakDeviceForm`, 'Новое оборудование'))
                break

            case 'psLeakDeviceLog':
                arr.push(createBreadcrumb('/psLeakDeviceLog', 'Системные логи'))
                if (routes[2]) {
                    if (psLeakDeviceLog) {
                        arr.push(createBreadcrumb(`/psLeakDeviceLog/${psLeakDeviceLog.id}`, psLeakDeviceLog.nameDevice))
                    }
                }
                break

            case 'psLeakDeviceLocalLog':
                arr.push(createBreadcrumb('/psLeakDeviceLocalLog', 'Логи устройств'))
                if (routes[2]) {
                    if (psLeakDeviceLocalLog) {
                        arr.push(createBreadcrumb(`/psLeakDeviceLocalLog/${psLeakDeviceLocalLog.id}`, psLeakDeviceLocalLog.nameDevice))
                    }
                }
                break

            case 'psLeakDeviceIndication':
                arr.push(createBreadcrumb('/psLeakDeviceIndication', 'Показания устройств'))
                if (routes[2]) {
                    if (psLeakDeviceIndication) {
                        arr.push(createBreadcrumb(`/psLeakDeviceIndication/${psLeakDeviceIndication.id}`, psLeakDeviceIndication.nameDevice))
                    }
                }
                break

            case 'securityLog':
                arr.push(createBreadcrumb('/securityLog', 'Логи охраны'))
                break

            case 'attributesVersion':
                arr.push(createBreadcrumb('/attributesVersion', 'Версии'))
                if (routes[2]) {
                    if (version) {
                        arr.push(createBreadcrumb(`/attributesVersion/${version.version}`, version.name))
                    }
                }
                break
            case 'attributesVersionForm':
                arr.push(createBreadcrumb('/attributesVersion', 'Версии'))
                if (versionForm) {
                    arr.push(createBreadcrumb(`/attributesVersion/${versionForm.version}`, versionForm.name))
                    arr.push(createBreadcrumb(`/attributesVersionForm`, 'Обновление версии', {version: versionForm}))
                } else arr.push(createBreadcrumb(`/attributesVersionForm`, 'Новая версия'))
                break
        }

        return arr
    }, [pathname, company, companyForm, objectGroup, objectGroupForm, object, objectForm, psLeakDevice, psLeakDeviceForm, userGroup, userGroupForm,
        psLeakDeviceLog, psLeakDeviceLocalLog, psLeakDeviceIndication, user, userForm, version, versionForm])

    return (
        <>
            <Row gutter={[24, 0]}>
                <Col span={24} md={18} style={{display: 'flex', alignItems: 'center'}}>
                    <div className="header-control">
                        <Button type="link"
                                className="sidebar-toggler"
                                onClick={() => onPress()}
                        >
                            {toggler}
                        </Button>
                    </div>
                    <Breadcrumb>
                        {breadcrumbName}
                    </Breadcrumb>
                </Col>
                <Col span={24} md={6} style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                    <HeaderNotification dispatch={dispatch}
                                        controller={controller}
                    />
                    <span style={{color: 'gray'}}>{profile?.email}</span>
                    <Button onClick={() => dispatch(logout({controller}))} type="link" size="middle">
                        Выход
                    </Button>
                </Col>
            </Row>
        </>
    )
})

const createBreadcrumb = (link: string, name: string, state?: any) => {
    return <Breadcrumb.Item key="name">
        <NavLink to={{
            pathname: link,
            state: state,
        }}>
            {name}
        </NavLink>
    </Breadcrumb.Item>
}